import * as React from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

interface IconProps {
  type: IconProp;
  style?: any;
  size?: SizeProp;
  className?: any;
  onClick?: (e: React.MouseEvent) => void;
}

const Icon = ({ type, style, onClick, className, ...props }: IconProps) => {
  return (
    <i className={cx('icon', `fa-${type}`, className)} onClick={onClick}>
      <FontAwesomeIcon icon={type} style={style} {...props} />
    </i>
  );
};

export default Icon;
